"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// ! Disable temporarily -> test if dependencies (JSON stringify) works
//import useIsCurrentLocation from "./useIsCurrentLocation";
function useFetch(settings) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var condition = arguments.length > 2 ? arguments[2] : undefined;
  var getDataAsResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var fetchOnlyOnFullPageLoad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  var _useState = (0, _react.useState)({
    _loading: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var _settings$authorizati = settings.authorization,
      authorization = _settings$authorizati === void 0 ? false : _settings$authorizati,
      data = settings.data,
      _settings$headers = settings.headers,
      headers = _settings$headers === void 0 ? {} : _settings$headers,
      _settings$method = settings.method,
      method = _settings$method === void 0 ? "GET" : _settings$method,
      url = settings.url; // ! Disable temporarily -> test if dependencies (JSON stringify) works
  // const isCurrentLocation = useIsCurrentLocation();

  var _dependencies = (0, _isArray.default)(dependencies) ? [JSON.stringify(dependencies)] : dependencies; // check if settings === string


  if (typeof settings === "string") {
    url = settings;
  }

  if (authorization && localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }

  (0, _react.useEffect)(function () {
    var controller = new AbortController();
    var signal = controller.signal;
    /**
     * fetch GET
     * params: url
     */

    var fetchGET = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, key, urlParams, request;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = [];

                for (key in data) {
                  if (data.hasOwnProperty(key)) {
                    params.push("".concat(key, "=").concat(data[key]));
                  }
                }

                urlParams = "";

                if (params.length > 0) {
                  urlParams = url.indexOf("?") > -1 ? "&" + params.join("&") : "?" + params.join("&");
                }

                _context.prev = 4;
                _context.next = 7;
                return _axios.default.get(url + urlParams, {
                  headers: headers,
                  signal: signal
                });

              case 7:
                request = _context.sent;
                setResult(getDataAsResult && request.data ? request === null || request === void 0 ? void 0 : request.data : request);
                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11]]);
      }));

      return function fetchGET() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * fetch POST
     * params: url, data
     */


    var fetchPOST = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var request;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.post(url, data, {
                  headers: headers,
                  signal: signal
                });

              case 3:
                request = _context2.sent;
                setResult(getDataAsResult && request.data ? request === null || request === void 0 ? void 0 : request.data : request);
                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function fetchPOST() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (typeof condition === "boolean" && !condition) {
      return;
    } // ! Disable temporarily -> test if dependencies (JSON stringify) works

    /*
    	if (fetchOnlyOnFullPageLoad && !isCurrentLocation && dependencies.length > 0) {
    		return;
    	}
    */


    if (method.toUpperCase() === "GET") {
      setResult({
        _loading: true
      });
      fetchGET();
      return;
    }

    if (method.toUpperCase() === "POST") {
      setResult({
        _loading: true
      });
      fetchPOST();
      return;
    }

    return function () {
      controller.abort();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  _dependencies);
  return result;
}

var _default = useFetch;
exports.default = _default;